import { Route, Routes } from "react-router";

import useTypedFlags from "hooks/useTypedFlags";

import VcsDetails from "../../VcsDetails";
import VcsDetailsNew from "../../VcsDetailsNew";

const VcsDetailsPage = () => {
  const { vcsImprovements } = useTypedFlags();

  return (
    <Routes>
      {vcsImprovements ? (
        <Route index path="*" element={<VcsDetailsNew />} />
      ) : (
        <Route index path="*" element={<VcsDetails />} />
      )}
    </Routes>
  );
};

export default VcsDetailsPage;
